import { AspectRatio } from "../components/common/DropDowns/StaticDropdown";
import { TgTrainingVersion } from "../pages/NewTG/Models/store/tg-model-store";

export type TextToImageConfigType = {
	// Core generation parameters
	model: string;
	model_version: string;
	aspect_ratio?: AspectRatio;
	medium?: string;
	prompt?: string;
	negative_prompt?: string;
	num_results?: number;
	steps_num?: number;
	seed?: number;
	displaySeed?: boolean;
	sync?: boolean;
	fast?: boolean;

	// Model selection
	model_id?: string | string[] | undefined;
	model_name?: string;
	tailored_model_id?: string | string[] | undefined;
	checkpoint_number?: string;
	tailored_model_influence?: number;
	training_version?: TgTrainingVersion;
	generation_prefix?: string;
	include_generation_prefix?: boolean;

	// Image enhancement and quality
	enhance_image?: boolean;
	format?: "png" | "svg";
	prompt_enhancement?: boolean;

	// Content moderation and safety
	content_moderation?: boolean;
	ui_type?: string;
	prompt_content_moderation?: boolean;
	ip_signal?: boolean;

	// Image reference and guidance
	image_reference?: ImageReferenceConfigsType;

	// Portrait restyling
	restyle_portrait?: boolean;

	// Guidance methods (ControlNet)
	guidance_method_1?: GuidanceMethodType;
	guidance_method_1_scale?: number;
	guidance_method_1_image_file?: string;
	guidance_method_2?: GuidanceMethodType;
	guidance_method_2_scale?: number;
	guidance_method_2_image_file?: string;

	// Image prompt adapter
	image_prompt_mode?: "regular" | "style_only";
	image_prompt_file?: string;
	image_prompt_urls?: string[];
	image_prompt_scale?: number;

	// Text guidance
	text_guidance_scale?: number;

	// Structured prompt
	structured_prompt?: string;
	structured_prompt_diff?: string;
	delta_prompt?: string;

	is_refine?: boolean;
	refine_prompt?: string;
};

export type GuidanceMethodType =
	"controlnet_canny" | "controlnet_depth" | "controlnet_recoloring" | "controlnet_color_grid";

export type ImageReferenceConfigsType = {
	structure_ref_influence?: number;
};

export type SyntheticEventProps = {
	target: {
		files: FileList | null;
		value: string;
	};
};

export enum modelTypes {
	Base = "base",
	Fast = "fast",
	Hd = "hd",
	Tailored = "tailored",
}

export type FiboModel = "fibo" | "fibo_lite";
